export enum NotificationAction {
     Errored = "Errored",
     Created = "Created",
     Completed = "Completed",
     Abandoned = "Abandoned",
     LevelApproved = "LevelApproved",
     NewComment = "NewComment",
     CommentResolved = "CommentResolved",

     Acknowledged = "Acknowledged",
     Updated = "Updated",
     PastDueDate = "PastDueDate",
     Deleted = "Deleted",
     Reassigned = "Reassigned",
     Unassigned = "Unassigned",

     ReportRendered = "Rendered",
     BatchReportRendered = "BatchRendered",
     BatchErrored = "BatchErrored",

     MaintenanceModeEnabled = "MaintenanceModeEnabled",
     
     UnpaidRegistration = "UnpaidRegistration",
     UnpaidAlarmBill = "UnpaidAlarmBill",
     UnregisteredAlarm = "UnregisteredAlarm",

     NewReleaseNote = "NewReleaseNote",
     DailyDigest = "DailyDigest"
}